<template>
  <div class="allApointments">
    <van-sticky>
      <div class="header">
        <div class="headerIcon">
          <van-icon name="arrow-left" color="#fff" @click="returnIndex" />
          <van-search v-model="value" placeholder="查找" @input="searchInput" />
        </div>
      </div>
    </van-sticky>
    <div v-if="tableData">
      <div class="allProject" v-for="(item,index) in tableData" :key="index">
        <leftTouch @onClick_two='onClick_two(item)'>
          <div @click="enterDetail(item)">
            <div class="outpatientList">
              <van-icon name="clock-o" color="#ABABB3" style="margin-right:.3rem" />
              <span>基本信息：</span>
              <span class="outName">{{item.draftsTitle}}</span>
            </div>
          </div>
        </leftTouch>
      </div>
    </div>
    <div v-if="tableData.length==0">
      <div class="indexWhite">
        <img src="../../assets/img/my-white.png" alt="">
      </div>
      <div class="whitePart">草稿箱暂无数据</div>
    </div>
  </div>
</template>
<script>
import { findAppointmentDraftsList, deleteAppointmentDrafts } from "@/axios/api";
import { Toast } from 'vant';
import leftTouch from "../common/leftTouch.vue";
export default {
  components: {
    leftTouch,
  },
  data() {
    return {
      value: '',
      tableData: [],
      status: '',
      areaType: localStorage.getItem('areaType')
    }
  },
  created() {
    this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
    this.status = JSON.parse(localStorage.getItem('userInfo')).status
    this.findDraftsList()
  },

  methods: {
    onClick_two(val) {
      deleteAppointmentDrafts({
        draftsId: val.id,
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            Toast.fail('删除成功');
            // this.findDraftsList()
            location.reload();
          } else {
            Toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    returnIndex() {
      this.$router.push("/aboutUs")
    },
    // 查询预约列表
    findDraftsList() {
      findAppointmentDraftsList({
        areaType: this.areaType,
        areaCode: this.areaType,
        userId: this.empId,
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            this.tableData = res.data;
          } else {
            Toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击进入详情页
    enterDetail(item) {
      console.log(item);
      this.$router.push({
        name: "copyAddAppointment",
        query: item,
      });
    },
    // 关键字查询
    searchInput(val) { }
  },
}

</script>
<style scoped>
@import "../../assets/css/allAppointments.css";
.outpatientList {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ababb3;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/page/darftList.vue